// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".left-list[data-v-0d6f8f92]{min-height:500px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
